export abstract class Source {
    private _dirty = true;
    isDirty() {
        return this._dirty;
    }

    protected setDirty() {
        this._dirty = true;
    }

    clearDirty() {
        this._dirty = false;
    }

    abstract hasData(): boolean;
}
